module.exports = __webpack_public_path__ + "img/Frame 30.c105268f.png";